import { inject, Injectable, InjectionToken } from '@angular/core';
import { Environment } from '../models/environment.model';

export const ENVIRONMENT_TOKEN = new InjectionToken<Environment>('environment', {
  factory: () => {
    throw new Error('No environment provided');
  }
});

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  environment: Environment = inject(ENVIRONMENT_TOKEN);
  constructor() { }

  getEnvironment(): Environment {
    return this.environment;
  }
}
